import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from 'ng-recaptcha';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';

import { AvatarModule } from '@libs/src/avatar/avatar.module';
import { DialogConfirmPromptModule } from '@libs/src/dialog-confirm-prompt/dialog-confirm-prompt.module';
import { SsoSigninModule } from '@libs/src/sso-signin/sso-signin.module';
import { TtcMatInputModule } from '@libs/src/ttc-mat-input/ttc-mat-input.module';
import { ProgressSpinnerModule } from '@main-client/src/app/progress-spinner/progress-spinner.module';

import { LoginService } from '@libs/src/login-form/login.service';
import { TenantsBackend } from '@libs/src/tenants/tenants.backend';
import { WorkplaceBackend } from '@libs/src/workplace/workplace.backend';
import { LocalStorageService } from '@main-client/src/app/core/local-storage.service';

import { LoginComponent } from './login.component';

import { environment } from '@libs/src/environments/environment';

@NgModule({
  declarations: [LoginComponent],
  exports: [LoginComponent],
  imports: [
    AvatarModule,
    CommonModule,
    DialogConfirmPromptModule,
    FlexLayoutModule,
    MatButtonModule,
    MatIconModule,
    NzFormModule,
    NzIconModule,
    NzInputModule,
    ProgressSpinnerModule,
    RouterModule.forChild([]),
    ReactiveFormsModule,
    RecaptchaV3Module,
    SsoSigninModule,
    TtcMatInputModule,
  ],
  providers: [
    { provide: RECAPTCHA_V3_SITE_KEY, useValue: environment.recaptcha.siteKey },
    LocalStorageService,
    LoginService,
    TenantsBackend,
    WorkplaceBackend,
  ],
})
export class LoginFormModule {}
